import {QueryOptions} from "@irati/utils/services/apollo"
import {User} from "@irati/types"
import onboardingService, {OnboardingStep} from "@irati/onboarding/services/onboarding"

class CategoriesService {
  shouldShowCategoriesBanner = (user: User, options: QueryOptions = {}): Promise<boolean> => {
    const userId = user.uuid
    return onboardingService.get(userId, options).then(({completedSteps}) => {
      return !completedSteps.includes(OnboardingStep.HAS_DISMISSED_CUSTOM_CATEGORIES_BANNER)
    })
  }
  dismissCategoriesBanner = (user: User) => {
    onboardingService.completeStep(user, OnboardingStep.HAS_DISMISSED_CUSTOM_CATEGORIES_BANNER)
  }
}

export default new CategoriesService()
